import { ImgHTMLAttributes, useState } from "react";

import { Alert } from "react-bootstrap";
import { InView } from "react-intersection-observer";

import Loader from "./Loader.tsx";

export const Image = (imageProps: ImgHTMLAttributes<HTMLImageElement>) => {
  const AsyncImage = ({
    inView,
    ...imagePropsAsync
  }: ImgHTMLAttributes<HTMLImageElement> & {
    inView: boolean;
  }) => {
    const [status, setStatus] = useState("loading");

    return (
      <div style={{ position: "relative" }}>
        {status === "failed" ? (
          <Alert
            className={"position-absolute top-50 start-50 translate-middle"}
            variant="danger"
          >
            Erreur chargement de l'image : {imagePropsAsync.src}
          </Alert>
        ) : status === "loading" ? (
          <Loader
            className={"position-absolute top-50 start-50 translate-middle"}
          />
        ) : null}
        {inView ? (
          <img
            {...imagePropsAsync}
            alt={imagePropsAsync.alt}
            onLoad={() => setStatus("loaded")}
            onError={() => setStatus("failed")}
          />
        ) : null}
      </div>
    );
  };

  return (
    <InView triggerOnce>
      {({ ref, inView }) => (
        <div ref={ref} className={imageProps.className}>
          <AsyncImage inView={inView} {...imageProps} />
        </div>
      )}
    </InView>
  );
};
